import React from 'react';
import { SortableElement, SortableHandle } from "react-sortable-hoc";
import Input from "../Input";

const Draggable = SortableHandle((props) => {
    return (
        <div className="drag-point">
            <i className="fas fa-sort"></i>
        </div>

    )
});

const Sortable = SortableElement(props => {
        return (
            <div className="sortable-item col-12">
                <div className="d-flex">
                    <div className="d-flex flex-column">
                        <Draggable {...props} />
                        <div className="delete-point" index={props.itemIndex} onClick={props.deleteButtonHandler}>
                            <i className="far fa-trash-alt"></i>
                        </div>
                    </div>
                    <div className="w-100">
                        <div className="row">
                            <div className="form-group col-6">
                                <label>Name</label>
                                <Input name={`elements.${props.itemIndex}.name`} value={props.element.name} onChange={props.onChange}/>
                            </div>
                            <div className="form-group col-6">
                                <label>Year</label>
                                <Input name={`elements.${props.itemIndex}.year`} value={props.element.year} onChange={props.onChange}/>
                            </div>
                        </div>
                        <div className="row">
                            <div className="form-group col-6">
                                <label>Project</label>
                                <Input name={`elements.${props.itemIndex}.project`} value={props.element.project} onChange={props.onChange}/>
                            </div>
                            <div className="form-group col-6">
                                <label>Project url</label>
                                <Input name={`elements.${props.itemIndex}.url`} value={props.element.url} onChange={props.onChange}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
);

export default Sortable;
